'use client';

import { QueryKeys } from '@/constants/query-keys';
import { moviesHeroScrollerApiService } from '@/services/(frontend)/movies/movies-hero-scroller-api.service';
import { MoviesHeroScrollerTile } from '@/types/movies-hero-scroller';
import { useQuery } from '@tanstack/react-query';
import { useDynamicStaleTime } from '../shared/dynamic-stale-time';

export const useMoviesHeroScroller = (
  theaterId: number,
  timeZone?: string
): ReturnType<typeof useQuery<MoviesHeroScrollerTile[] | undefined>> => {
  const updateQueryStaleTime = useDynamicStaleTime();
  const queryKey = QueryKeys.global.moviesHeroScroller(theaterId, timeZone);

  return useQuery({
    queryFn: async ({ signal }) => {
      const response = await moviesHeroScrollerApiService.getTiles(theaterId || undefined, timeZone, signal);
      updateQueryStaleTime(queryKey, response.headers);
      return response.data;
    },
    queryKey,
  });
};
